export default (data) => ({
  id: data[0],
  title: data[1],
  type: data[2],
  latitude: data[3],
  longitude: data[4],
  slug: data[5],
  thumbnail: data[7],
});
